import React, { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { Box, IconButton, Tab, Tabs, Typography } from "@mui/material";
import ConnectedCallTable from "./ConnectedCallTable";
import MissedCallTable from "./MissedCallTable";
import FilterComponent from "./FilterComponent";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import FilterListIcon from "@mui/icons-material/FilterList";
import Loader from "../../reusable Component/Loader";
import { FISH_FEED_INCOMMING_CALL } from "../../../constants";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

function IncommingCallsFishFeed({}) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"), // 7 days ago
    endDate: dayjs().format("YYYY-MM-DD"), // Today
  });

  const [callStatistics, setCallStatistics] = useState([]);
  const [metricData, setMetricData] = useState([]);

  const [tabValues, setTabValues] = useState(0); // Default to the first tab

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setTabValues(newValue); // Update the current tab index
  };

  const [filterShow, setFilterShow] = useState(false);

  const handleExport = async () => {
    try {
      setLoading(true);
      const { startDate, endDate, agentName } = filters;
      const agentNumber =
        localStorage.getItem("empRole") === "300"
          ? JSON.parse(localStorage.getItem("userData"))?.EmployeePhone
          : 7880162561;

      // Common query params
      const commonParams = `startDate=${startDate}&endDate=${endDate}&agentNumber=${agentNumber}&page=1&pageSize=10000`;

      // Fetch connected and missed calls
      const [connectedRes, missedRes] = await Promise.all([
        axios.get(
          `${FISH_FEED_INCOMMING_CALL}?${commonParams}&callStatus=Connected`
        ),
        axios.get(
          `${FISH_FEED_INCOMMING_CALL}?${commonParams}&callStatus=Missed`
        ),
      ]);

      const connectedCalls = connectedRes.data.calls || [];
      const missedCalls = missedRes.data.calls || [];

      // Add connection status to each call
      const connectedCallsWithStatus = connectedCalls.map((call) => ({
        ...call,
        connectionStatus: "Connected",
      }));

      const missedCallsWithStatus = missedCalls.map((call) => ({
        ...call,
        connectionStatus: "Missed",
      }));

      const allCalls = [...connectedCallsWithStatus, ...missedCallsWithStatus];

      // Create main calls sheet data
      const callsData = allCalls.map((call) => ({
        "Call ID": call.callId || "-",
        "Caller Number": call.callerNumber || "-",
        "Connection Status": call.connectionStatus || "-", // Added this line
        "Agent Name": call.employeeDetails?.EmployeeName || "-",
        "Agent Employee ID": call.employeeDetails?.EmployeeId || "-",
        "Agent Phone": call.employeeDetails?.EmployeePhone || "-",
        "Call Start Time": call.callStartTime
          ? dayjs(call.callStartTime).format("YYYY-MM-DD HH:mm:ss")
          : "-",
        "Call End Time": call.callEndTime
          ? dayjs(call.callEndTime).format("YYYY-MM-DD HH:mm:ss")
          : "-",
        "OG Start Time": call.ogStartTime
          ? dayjs(call.ogStartTime).format("YYYY-MM-DD HH:mm:ss")
          : "-",
        "OG End Time": call.ogEndTime
          ? dayjs(call.ogEndTime).format("YYYY-MM-DD HH:mm:ss")
          : "-",
        "OG Call Status": call.ogCallStatus || "-",
        "Total Call Duration (seconds)": call.totalCallDuration || 0,
        Duration: call.duration || "-",
        "Is Connected": call.isConnected ? "Yes" : "No",
        "Call Date": call.callDate || "-",
        "Call Time": call.callTime || "-",
        "Voice Recording": call.voiceRecording || "-",
        // Shrimp Feed Details
        "Farmer Village": call.shrimpFeedDetails?.farmerVillage || "-",
        Region: call.shrimpFeedDetails?.region || "-",
        "Shrimp Zone": call.shrimpFeedDetails?.shrimpZone || "-",
        "Dealer Name": call.shrimpFeedDetails?.dealerName || "-",
        "Dealer Code": call.shrimpFeedDetails?.dealerCode || "-",
        State: call.shrimpFeedDetails?.state || "-",
        "Postal Code": call.shrimpFeedDetails?.postalCode || "-",
        "Feed Type": call.shrimpFeedDetails?.feedType || "-",
        "Employee Code": call.shrimpFeedDetails?.employeeCode || "-",
        "Farmer Type": call.shrimpFeedDetails?.farmerType || "-",
        "Last Action Date": call.shrimpFeedDetails?.lastActionDate
          ? dayjs(call.shrimpFeedDetails.lastActionDate).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "-",
        "Customer Status": call.shrimpFeedDetails?.status || "-",
        Latitude: call.shrimpFeedDetails?.latitude || "-",
        Longitude: call.shrimpFeedDetails?.longitude || "-",
        Remarks: call.shrimpFeedDetails?.remarks || "-",
      }));

      // Create feed remarks sheet data (flattened)
      const feedRemarksData = [];
      allCalls.forEach((call) => {
        if (
          call.shrimpFeedDetails?.feedRemarks &&
          call.shrimpFeedDetails.feedRemarks.length > 0
        ) {
          call.shrimpFeedDetails.feedRemarks.forEach((remark) => {
            feedRemarksData.push({
              "Call ID": call.callId || "-",
              "Caller Number": call.callerNumber || "-",
              "Connection Status": call.connectionStatus || "-", // Added this line
              // "Remark ID": remark.id || "-",
              Type: remark.type || "-",
              "Prospect Farmer Category": remark.prospectFarmerCategory || "-",
              Name: remark.name || "-",
              "Mobile Number": remark.mobileNumber || "-",
              "Pond Location": remark.pondLocation || "-",
              District: remark.district || "-",
              "Postal Code": remark.postalCode || "-",
              State: remark.state || "-",
              "Fish Species": remark.fishSpecies || "-",
              "Number of Ponds": remark.numberOfPonds || "-",
              "Pond Area (Acres)": remark.pondAreaInAcres || "-",
              "Current Feed Used": remark.currentFeedUsed || "-",
              "Is Stocking": remark.isStocking || "-",
              "Stocking Density": remark.stockingDensity || "-",
              "Days of Culture": remark.daysOfCulture || "-",
              "Is Harvesting": remark.isHarvesting || "-",
              "Harvesting Quantity": remark.harvestingQuantity || "-",
              "Potentiality (MT)": remark.potentialityInMT || "-",
              Status: remark.status || "-",
              "Follow Up Date": remark.followUpDate
                ? dayjs(remark.followUpDate).format("YYYY-MM-DD")
                : "-",
              Purpose: remark.purpose || "-",
              "Agent Remarks": remark.agentRemarks || "-",
              // "Call ID": remark.callId || "-",
              "Call Type": remark.callType || "-",
              // "Created At": remark.createdAt
              //   ? dayjs(remark.createdAt).format("YYYY-MM-DD HH:mm:ss")
              //   : "-",
              // "Updated At": remark.updatedAt
              //   ? dayjs(remark.updatedAt).format("YYYY-MM-DD HH:mm:ss")
              //   : "-",
            });
          });
        }
      });

      // Create workbook with multiple sheets
      const workbook = XLSX.utils.book_new();

      // Add main calls sheet
      const callsWorksheet = XLSX.utils.json_to_sheet(callsData);
      XLSX.utils.book_append_sheet(workbook, callsWorksheet, "Incoming Calls");

      // Add feed remarks sheet if there's data
      if (feedRemarksData.length > 0) {
        const remarksWorksheet = XLSX.utils.json_to_sheet(feedRemarksData);
        XLSX.utils.book_append_sheet(
          workbook,
          remarksWorksheet,
          "Feed Remarks"
        );
      }

      // Add summary sheet
      const summaryData = [
        { Metric: "Total Calls", Value: allCalls.length },
        { Metric: "Connected Calls", Value: connectedCalls.length },
        { Metric: "Missed Calls", Value: missedCalls.length },
        { Metric: "Total Feed Remarks", Value: feedRemarksData.length },
        { Metric: "Export Date", Value: dayjs().format("YYYY-MM-DD HH:mm:ss") },
        {
          Metric: "Date Range",
          Value: `${startDate} to ${endDate}`,
        },
      ];
      const summaryWorksheet = XLSX.utils.json_to_sheet(summaryData);
      XLSX.utils.book_append_sheet(workbook, summaryWorksheet, "Summary");

      // Write the file
      XLSX.writeFile(
        workbook,
        `incoming_calls_${startDate}_to_${endDate}.xlsx`
      );

      console.log(
        `Exported ${allCalls.length} incoming calls with ${feedRemarksData.length} feed remarks`
      );
    } catch (err) {
      console.error("Export error:", err);
      alert("Failed to export call data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader open={loading} />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, paddingLeft: "12px", flexGrow: 1 }}
        >
          Incoming Call Report
        </Typography>

        {/* IconButton aligned to the right */}
        <IconButton
          onClick={() => setFilterShow((prev) => !prev)}
          style={{
            border: "1px solid #fff", // Change border color to white for contrast
            borderRadius: "4px",
            margin: "5px",
            width: "40px", // Increased width for a more comfortable click area
            height: "40px", // Increased height for a more comfortable click area
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#097969",
            color: "#fff",
            transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
            e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#097969"; // Original color
            e.currentTarget.style.transform = "scale(1)"; // Reset scale
          }}
        >
          <FilterListIcon />
        </IconButton>

        {/* IconButton aligned to the right */}
        <IconButton
          onClick={handleExport}
          style={{
            border: "1px solid #fff",
            borderRadius: "4px",
            margin: "5px",
            width: "40px",
            height: "40px",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#097969",
            color: "#fff",
            transition: "background-color 0.3s, transform 0.2s",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0B9B73";
            e.currentTarget.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#097969";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <FileDownloadIcon />
        </IconButton>
      </Box>

      {filterShow && (
        <FilterComponent
          filters={filters}
          setFilters={setFilters}
          data={callStatistics}
          setFilterShow={setFilterShow}
        ></FilterComponent>
      )}

      <Box
        display="flex"
        justifyContent="space-between"
        gap="16px"
        sx={{
          padding: "16px",
          backgroundColor: "#EEF0F4",
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        {/* Total Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Total Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.connectedCalls + metricData.missedCalls || 0}
          </Typography>
        </Box>

        {/* Connected Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Connected Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.connectedCalls || 0}
          </Typography>
        </Box>

        {/* Missed Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Missed Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.missedCalls || 0}
          </Typography>
        </Box>

        {/* Total Talk time */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Total Connected Time
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.totalDuration || 0}
          </Typography>
        </Box>
      </Box>

      <Tabs
        value={tabValues} // Current selected tab
        onChange={handleTabChange} // Handle tab change
        aria-label="Call Statistics Tabs"
      >
        {/* Tab for Connected Calls */}
        <Tab
          label={`Connected (${metricData.connectedCalls || 0})`}
          id="tab-0"
          aria-controls="tabpanel-0"
        />
        {/* Tab for Missed Calls */}
        <Tab
          label={`Missed (${metricData.missedCalls || 0})`}
          id="tab-1"
          aria-controls="tabpanel-1"
        />
      </Tabs>

      {/* Tab Panels */}
      <TabPanel value={tabValues} index={0}>
        <ConnectedCallTable
          filters={filters}
          setFilters={setFilters}
          setMetricData={setMetricData}
          setLoading={setLoading}
        />
      </TabPanel>
      <TabPanel value={tabValues} index={1}>
        <MissedCallTable
          filters={filters}
          setFilters={setFilters}
          setMetricData={setMetricData}
          setLoading={setLoading}
        />
      </TabPanel>
    </>
  );
}
export default IncommingCallsFishFeed;
